import { ChangeDetectionStrategy, Component, computed, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController, RefresherEventDetail, ViewDidEnter } from '@ionic/angular';
import { MenuService } from '../../providers/menu.service';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AccesRapideWidgetComponent } from './acces-rapide-widget/acces-rapide-widget.component';
import { UserService } from '../../providers/auth/user.service';
import { HeuresSaisiesWidgetComponent } from './heures-saisies-widget/heures-saisies-widget.component';
import { SitesFavorisWidgetComponent } from './sites-favoris-widget/sites-favoris-widget.component';
import { DailyOtsWidgetComponent } from './daily-ots-widget/daily-ots-widget.component';
import { User } from '../../providers/auth/user.model';
import { RechercheSiteOtModal } from 'src/app/mnt/common/modals/recherche-site-ot/recherche-site-ot.modal';
import { ConduiteP1WidgetComponent } from './conduite-p1-widget/conduite-p1-widget.component';
import { CentreNotificationService } from '../../../mnt/centre-notification/centre-notification.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

/**
 * Page d'accueil.
 */
@Component({
  selector: 'page-accueil',
  templateUrl: 'accueil.page.html',
  styleUrls: ['accueil.page.scss'],
  imports: [
    DailyOtsWidgetComponent,
    SitesFavorisWidgetComponent,
    HeuresSaisiesWidgetComponent,
    AccesRapideWidgetComponent,
    CommonModule,
    IonicModule,
    TranslateModule,
    ConduiteP1WidgetComponent,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccueilPage implements OnInit, ViewDidEnter {
  user: User;
  resetSubject: Subject<boolean> = new Subject<boolean>();

  readonly centreNotification = toSignal(this.centreNotificationService.centreNotificationData$);
  notificationsNonLues = computed(() => {
    if (this.centreNotification() && this.centreNotification().notifications) {
      return this.centreNotification().notifications.filter((n) => n.isRead === false).length;
    }
    return 0;
  });

  constructor(
    private readonly menuService: MenuService,
    private readonly userService: UserService,
    private readonly modalCtrl: ModalController,
    private readonly centreNotificationService: CentreNotificationService,
    private readonly router: Router
  ) {
    this.user = this.userService.getCurrentUser();
  }

  get burgerBadge(): number {
    return this.menuService.getNotifications();
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async ionViewDidEnter() {
    await this.refresh();
  }

  async doRefresh(refresher: CustomEvent<RefresherEventDetail>) {
    await this.refresh();

    setTimeout(() => {
      refresher.detail.complete();
    }, 500);
  }

  private async refresh() {
    this.centreNotificationService.chargerDonnesCentreNotification().then();
    this.resetSubject.next(true);
  }

  async openRechercheModal() {
    const modal = await this.modalCtrl.create({
      component: RechercheSiteOtModal,
      componentProps: { agendaJours: null },
    });
    //
    await modal.present();
    //
    modal.onDidDismiss().then((data) => {
      if (data) {
        console.log(data);
      }
    });
    await modal.present();
  }

  async openCentreNotification() {
    await this.router.navigate(['/mnt/centre-notification']);
  }
}
